import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Header, CollapsibleWidget, Icon, Modal } from 'components/patterns'
import { Switch } from 'components/patterns/Inputs'

import ModuleNameRadioEditor from 'components/feature/FeatureEditor/ModuleNameRadioEditor'

export const StyledFeaturePreCreateModal = styled(Modal)`
  &&& {
    .ant-modal-header {
      padding: 16px;
    }
    .ant-modal-title {
      width: 100%;
    }
    .ant-modal-body {
      background-color: ${themeColor('modalGrey')};
      padding-top: 25px;
      padding-bottom: 0px;
      overflow-y: auto;
      max-height: 500px;
    }
    .ant-modal-footer {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }

    /* Error state: let the modal body shrink to fit ModalErrorContent naturally.
       overflow-y: hidden removes the scrollbar that appears when the content is
       shorter than the normal max-height. */
    &.modal-error-state .ant-modal-body {
      overflow-y: hidden;
      max-height: none;
    }
  }
`

export const StyledModalHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`

export const StyledModalHeader = styled(Header)``

export const HeaderStyled = styled.div`
  margin-bottom: 18px;
`

export const StyledModuleName = styled.span`
  font-weight: bold;
`

export const StyledDescriptionInput = styled.div`
  margin-bottom: 20px;
`

export const StyledBusSwitch = styled(Switch)`
  margin-bottom: 10px;
`

export const StyledModuleNameRadioEditor = styled(ModuleNameRadioEditor)`
  margin-bottom: 10px;
`

export const StyledCollapsibleWidget = styled(CollapsibleWidget)`
  background-color: ${themeColor('modalGrey')};
  &&.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    margin-top: -20px;
    margin-left: -20px !important;
  }
  &&.ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    left: 150px;
  }
  &&.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
    margin-top: -6px;
    border-bottom: 0px;
  }
  &&.ant-collapse-borderless > .ant-collapse-item {
    border-bottom: 0px;
  }
`

export const StyledWidgetHeader = styled.span`
  height: 12px;
  color: ${themeColor('bluePrimary')};
`

export const InfoIcon = styled(Icon)`
  fill: ${themeColor('blackSecondary')};
  &&& {
    height: 14px;
    width: 24px;
    top: 12px;
    left: 13px;
  }
`

export const SchoolBusMessage = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  margin-bottom: 15px;
`
